import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_TEMPLATES_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_GET_SURVEYS_TEMPLATES_CALL, KEY_GET_TEMPLATES } from '../constats';
import { MOCK_RESPONSE_GET_TEMPLATES } from '../mocks';

export type ResponseGetSurveyTemplates = GenericGet<
  typeof API_TEMPLATES_PATH_KEY
>['response']['body'];

type CallParamsGetSurveyTemplates = {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponseGetSurveyTemplates = ResponseGetSurveyTemplates;

type CallErrorGetSurveyTemplates = GenericApiError;

type CallSelectorsGetSurveyTemplates = {
  menu: { name: string; id: string }[];
  softSkillTemplate: ResponseGetSurveyTemplates[0];
  hardSkillTemplate: ResponseGetSurveyTemplates[0];
  chipsList: string[];
};

export const getTemplatesCall = createGeneralCall<
  CallParamsGetSurveyTemplates,
  CallResponseGetSurveyTemplates,
  CallErrorGetSurveyTemplates,
  CallSelectorsGetSurveyTemplates
>({
  id: KEY_GET_TEMPLATES,
  method: 'get',
  url: () => () => {
    return API_GET_SURVEYS_TEMPLATES_CALL();
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_TEMPLATES : undefined,
  selectors: {
    menu: ({ selectors }) =>
      createSelector(
        selectors.response,
        res =>
          (res.length > 0 &&
            res
              ?.filter(item => item.name === 'Soft skills' || item.name === 'Hard skills')
              .map(item => ({
                name: item.name ?? '',
                id: item.id ?? '',
              }))) ||
          [],
      ),
    chipsList: ({ selectors }) =>
      createSelector(
        selectors.response,
        res => (res.length > 0 && res.map(item => item.name ?? '')) || [],
      ),
    softSkillTemplate: ({ selectors }) =>
      createSelector(selectors.response, res => {
        const found = Array.isArray(res)
          ? res.find(item => item.name === 'Soft skills')
          : undefined;
        return (
          found ?? {
            id: '',
            name: '',
            isActive: false,
            metrics: [],
            versions: [],
          }
        );
      }),
    hardSkillTemplate: ({ selectors }) =>
      createSelector(selectors.response, res => {
        const found = Array.isArray(res)
          ? res.find(item => item.name === 'Hard skills')
          : undefined;
        return (
          found ?? {
            id: '',
            name: '',
            isActive: false,
            metrics: [],
            versions: [],
          }
        );
      }),
  },
});
